<template>
    <div class="produtos-destaques">
        <div class="destaques-inner destaques-shadow p-3">
            <!-- DESTAQUES -->
            <div class="row px-4" v-if="showDestaques">
                <div class="col-12">
                    <i class="fa fa-close float-right mr-n3" id="destaques-close" @click="handleClose"></i>
                </div>
                <div class="input-group mb-2">
                    <strong style="font-size:12px">Buscar Destaque</strong>
                    <input ref="pesquisaDestaque" v-model="numeroDestaque" style="font-size:17px" class="col-12 vd-input px-2 py-1" id="search" type="text" autocomplete="off"
                        @keyup.enter="numeroDestaque ? showItemsDestaque(destaques[0].coddestaq): ''">
                </div>
                <div class="card col-md-3" style="width: 8rem;" v-for="(destaque, i) in destaques" :key="i">
                    <div class="card-content" @click="showItemsDestaque(destaque.coddestaq)">
                        <img :src="destaque.url" class="card-img-top" alt="Product Image" v-if="destaque.url">
                        <!-- <div class="badge">{{ product.qty }}</div> -->
                        <div class="card-img d-flex justify-content-center align-items-center bg-light p-4" v-if="!destaque.url">
                            <i class="fa fa-camera"></i>
                        </div>
                        <div class="card-body d-flex align-items-center" style="word-break:break-all; ">
                            <span class="mr-1" style="font-size:18px"> <strong class="text-dark" >#{{ destaque.coddestaq }}</strong></span><span style="font-size:13px">{{ destaque.descricao }}</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- PRODUTOS -->
            <div class="row px-4" v-if="showItems">
                <div class="col-12">
                    <span @click="handleReturnDestaques">
                        <i class="fa fa-arrow-left" id="returnDestaques"></i> 
                        <span class="returnDestaques">Voltar</span>
                    </span>
                    <i class="fa fa-close float-right mr-n3" id="destaques-close" @click="handleClose"></i>
                </div>
                <button class="border p-0 col-md-3 mr-2 my-1" style="width: 8rem; background: white;" v-for="(product, i) in products" @click="showModalDetalhes(product)" :key="i" :id="`id${i}`"
                    @keyup.right="handleRight(i)"  @keyup.left="handleLeft(i)" >
                    <div class="card-content" :id="`id${i}`">
                        <img :src="product.url" class="card-img-top" alt="Product Image" v-if="product.url" :id="`id${i}`">
                        <div class="badge" :id="`id${i}`">{{ product.qty }}</div>
                        <div class="card-img d-flex justify-content-center align-items-center bg-light p-4" v-if="!product.url" :id="`id${i}`">
                            <i class="fa fa-camera"></i>
                        </div>
                        <div class="card-body d-flex flex-column" :id="`id${i}`">
                            <span :id="`id${i}`">{{ product.descricao }}</span>
                            <strong :id="`id${i}`">R${{ product.vlrtab | formatValue }}</strong>
                        </div>
                    </div>
                </button>
            </div>
        </div>
        
        <!-- MODAL DETALHES -->
        <div class="nb-modal-scrollable" v-if="showModal">
            <div class="container nb-modal-scrollable-container nb-email-container">
                <div class="nb-modal-scrollable-body mt-3">
                    <div class="modal-container">
                        <div class="product-img d-flex justify-content-center" v-if="product.url">
                            <img :src="product.url" alt="Product Image">
                        </div>
                        <div class="product-img d-flex justify-content-center align-items-center bg-light p-4" v-if="!product.url">
                            <i class="fa fa-camera"></i>
                        </div>
                        <div class="product-details d-flex flex-column text-center mt-3">
                            <strong v-if="product">R${{ product.vlrtab | formatValue }}</strong>
                            <h5>{{ product.descricao }}</h5>
                        </div>
                        <div class="product-qty d-flex justify-content-center mt-2">
                            <button class="qty-control" @click="subtract"><i class="fa fa-minus"></i></button>
                            <input type="number" v-model="productQty" @keydown.enter="handleEnter()" id="quantidadedest">
                            <button class="qty-control" @click="productQty++"><i class="fa fa-plus"></i></button>
                            <div class="d-flex align-items-center ml-2">
                                <strong>{{product.uni}}</strong>
                            </div>
                        </div>
                        <div class="product-obs mt-3">
                            <span class="lbl-edit">Observações</span>
                            <input class="form-control  form-control-sm" ref="destaqueobs" type="text" @keydown.enter="handleEnterObs()" v-model="product.obs" >
                        </div>
                        <div class="actions d-flex justify-content-center mt-4 mb-5">
                            <button class="btn btn-danger" @click="showCloseDetalhes">Cancelar</button>
                            <button class="btn" ref="btnAdic" @click="handleAdicionar(product, productQty)">Adicionar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
import FormField from './form-field.vue'
export default {
    components: {
        FormField,
    },
    props: {
        tabelaPreco: {
            type: String,
            require: true
        },
        itemsList: {
            type: Array,
            require: true
        },
    },
    data() {
        return {
            product: null,
            productQty: 1,
            showDestaques: true,
            showItems: false,
            showModal: false,
            numeroDestaque: null,
            destaques: null,
            interval: null,
        }
    },
    computed: {
        
        nextPage: function () {
            return this.$store.getters.getNextPage
        },
        destaqList: function () {
            return this.$store.getters.getDestaqList
        },
        products() {
            return this.$store.getters.getItemSalesList
        }
    },
    methods:{

        handleEnterObs(){
            this.$nextTick(function (){
                this.$refs.btnAdic.focus()
            })
        
        },
        handleRetorna(){
            if(this.showModal){
                this.showCloseDetalhes()
                this.$nextTick(function (){
                    document.getElementById(`id${0}`).focus()
                })
            }
            if(!this.showItems && this.showDestaques){
               this.handleClose()
            }
    
        },
        handleEnter(){
            this.$nextTick(async function  (){
              await  this.$refs.destaqueobs.focus()
            })
        },
        handleLeft(i){
            let indice = i -1
            if(indice < 0){
                this.handleReturnDestaques()
                return;
            }

            document.getElementById(`id${indice}`).focus()

        },
        handleRight(i){
            let indice = i+1
            if( indice >= this.products.length ){
                return;
            }
            this.$nextTick(function (){
                document.getElementById(`id${indice}`).focus()
            })
        },
        async loadDestaques(numeroDestaque){
            const destaques = this.$store.getters.getDestaqList.filter(dest =>{
                let desc = dest.descricao.toString()
                if(numeroDestaque)
                    return desc.match(numeroDestaque) || dest.coddestaq.match(numeroDestaque)
                else 
                    return dest
            })
            this.destaques = destaques
        },
        async loadData() {
            await this.$store.dispatch('loadDestaq', { 
                filter: '', 
                page: this.nextPage 
            }) 
            this.loadDestaques()
        },
        async showItemsDestaque(coddestaq) {
            if (!coddestaq) return

            await this.$store.dispatch('loadItemSales', { 
                codtabpre: this.tabelaPreco, 
                codpedv: 0, 
                filter: `{"coddestaq":{"$eq":${coddestaq}}}`,
                produtosDestaque: true
            })

            this.qtyItem();
            this.showDestaques = false
            this.showItems = true
            this.$nextTick(function (){
                document.getElementById(`id${0}`).focus()
            })

        },
        showModalDetalhes(product) {
            this.product = product
            this.showModal = true
            var self = this;
            this.$nextTick(()=>{
                document.getElementById('quantidadedest').focus();
            })
        },
        showCloseDetalhes() {
            this.showModal = false
            document.getElementById(`id${0}`).focus()
            this.productQty = 1
        },
        handleAdicionar(product, productQty) {
            product.quantidade = parseInt(productQty);
            product.qty += parseInt(product.quantidade)
            this.$emit('newItem', product)
            this.showCloseDetalhes()
            this.$nextTick(function (){
                document.getElementById(`id${0}`).focus()
            })
        },
        handleClose() {
            this.$emit('closeDestaques')
        },
        subtract() {
            if (this.productQty === 1) {
                return
            }
            this.productQty--
        },
        qtyItem() {
            const items = this.itemsList
            const products = this.products

            for (let i = 0; i < products.length; i++) {
                const product = products[i];
                product.qty = 0
                
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];

                    if (item.coditem == product.coditem) {
                        product.qty = parseInt(product.qty) + parseInt(item.qt)  
                    }
                }
            }
        },
        handleReturnDestaques() { 
            this.loadData();
            this.showDestaques = true
            this.showItems = false
            
            this.$nextTick(function (){
                this.$refs.pesquisaDestaque.focus()
            })
        }
    },
    created() {
        this.loadData()
        this.$nextTick(function (){
            this.$refs.pesquisaDestaque.focus()
        })
    },
    mounted(){
        var self = this;

        window.addEventListener('keyup', function (event){
            if(event.keyCode == 27){
                self.handleRetorna();
            }
        })

       
        
    },
    destroyed(){
        clearInterval(this.interval)
        this.interval = ''
    },
    watch:{
        numeroDestaque(){
            if(this.numeroDestaque){
               this.interval = setInterval(()=>{
                    this.loadDestaques(this.numeroDestaque.toUpperCase())
                }, 200)
            }
        }
    }
}
</script>

<style socped>
.produtos-destaques {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    transition: all .35s;
    will-change: transform;
    z-index: 10000;
}

.destaques-inner {
    background-color: #fff;
    overflow: hidden;
    height: 100%;
    width: 50vw;
}

.destaques-shadow {
    box-shadow: 0 0 32px 0 #a9aaac80;
}

#destaques-close {
    padding: .5rem;
    font-size: 1.1rem;
    color: #7f808380;
    cursor: pointer;
}

#returnDestaques {
    padding: .5rem;
    font-size: 1.1rem;
    color: #7f808380;
    cursor: pointer;
}

.returnDestaques {
    color: #55565880;
    font-size: .85rem;
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
}

.card {
    padding: .25rem;
    border: none !important;
}

.card-content {
    border-radius: 5px;
    border: 1px solid #c3c3c3;
    cursor: pointer;
}

.card-body {
    padding: .85rem .5rem !important;
}

.card-body span {
    font-size: .75rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    /* -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical; */
}

.card-img {    
    border-radius: 5px;
}

.card-img i {
    color: #c3c3c3;
    font-size: 3rem;
}

.nb-modal-scrollable-container {
    width: 80%;
    margin: auto;
}

.nb-modal-scrollable-container {
    border: 1px solid #c3c3c3;
    border-radius: 7px;
}

.nb-modal-header {
    border: none !important;
}

.modal-container {
    width: 50%;
    margin: auto;
}

.card-img-top {
    height: 8rem;
}

.card-img {
    min-height: 8rem;
}

.badge {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 10px;
    right: 10px;
    color: #fff;
    width: 20px;
    height: 20px;
    background-color: #265074;
}

.product-img {
    width: 100%;
    height: 15rem;
}

.product-img i {
    color: #c3c3c3;
    font-size: 5rem;
}

.product-details {
    color: #343a40;
}

.product-details strong {
    color: #636262;
    font-size: 1.5rem;
}

.product-qty input {
    outline: none;
    font-size: 1.1rem;
    font-weight: 600;
    width: 3rem;
    margin: 0;
    padding: 0 .5rem;
    border: 1px solid #aca9a9;
}

.product-qty button {
    outline: none;
    color: #fff;
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1.1rem;
    font-weight: 700;
    border: 1px solid #aca9a9;
    background-color: #aca9a9;
}

.actions .btn {
    color: #fff;
    font-size: 1.1rem;
    font-weight: 500;
    padding: .25rem 1.5rem;
    margin: 0 .25rem;
    background-color: #265074;
}

.actions .btn-danger {
    color: #fff;
    background-color: #dc3545;
}

@media only screen and (max-width: 990px) {
	.destaques-inner {
        width: 100%;
        margin: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/produtos-destaques.vue